const LOCAL_TURNSTILE_HOSTNAMES = new Set([
  "localhost",
  "127.0.0.1",
  "0.0.0.0",
  "::1",
  "[::1]",
]);

function normalizeHostname(hostname?: string): string | null {
  if (!hostname) {
    return null;
  }

  return hostname.trim().replace(/:\d+$/, "").toLowerCase();
}

export function isLocalTurnstileHostname(hostname?: string): boolean {
  const normalized = normalizeHostname(hostname);

  if (!normalized) {
    return false;
  }

  return LOCAL_TURNSTILE_HOSTNAMES.has(normalized);
}

export function shouldUseTurnstileSandbox(hostname?: string): boolean {
  return (
    process.env.NODE_ENV !== "production" && isLocalTurnstileHostname(hostname)
  );
}

/**
 * `next start` (Playwright) is production, so the normal sandbox check is off.
 * A form that waits on Turnstile still needs the local dummy key when the
 * public site key was not inlined at build time. Other forms leave this off
 * so an idle widget does not mount over the page.
 */
export function shouldUseLocalSandboxKey(
  hostname: string | undefined,
  preferLocalSandbox: boolean,
): boolean {
  return shouldUseTurnstileSandbox(hostname) || (preferLocalSandbox && isLocalTurnstileHostname(hostname));
}
